
const TYPES = {

    MSG_STATE: {
        SENDING: 0,
        SENT_ISREAD: 1,
        SENT_ISNOTREAD: -1,
        SENT_SUCCESS: 2,
        SENT_FAIL: 3,
    },

    MSG_FROM: {
        USER: 1,
        CUSTOMER: 2,
        USER_SYSTEM: 3,
        CUSTOMER_SYSTEM: 4,
        USER_KEYWORD: 5,
    },

    MSG_TYPE: {
        TEXT: 'text',
        IMAGE: 'image',
        GEO: 'location',
        JOIN: 'join',
        QUIT: 'quit',
        GOODS: 'goods',
        FILE:'file',
        VIDEO: 'video'
    }
}

export default TYPES
